import { Button, Modal } from 'avo-ui'
import icX from 'assets/images/ic-x.svg'
import { useRef } from 'react'
import { useReactToPrint } from 'react-to-print'
import moment from 'moment/moment'
import icLogo from 'assets/images/logo-blue.png'
import { formatDateMoment } from 'utils/utils'
import './table.scss'

export const PrintManifestModal = ({ show, onHide, isLoading, list, printManifestHandler }) => {
    const contentRef = useRef(null)
    const reactToPrintFn = useReactToPrint({
        contentRef,
        documentTitle: `MSBB Manifest - ${moment().format('DD-MM-YYYY HH-mm')}`,
    })

    return (
        <Modal dialogClassName={'w-2/3'} contentClassName={'rounded-xl overflow-scroll'} show={show} onHide={onHide}>
            <div className={'flex px-3 pt-3 justify-end'}>
                <img className={'w-5 cursor-pointer'} src={icX} alt='ic-x' onClick={onHide} />
            </div>
            <div className={'text-neutral-80 text-[13px] font-Bold p-5'} ref={contentRef}>
                <div className={'flex flex-col items-center justify-center space-y-3 mb-5'}>
                    <img src={icLogo} className={'h-14'} alt={'logo'} />
                    <p className={'text-lg tracking-[10px]'}>MANIFEST</p>
                </div>
                <div className={'flex flex-col space-y-2'}>
                    <div className={'flex items-center space-x-3'}>
                        <p className={'w-28'}>ID Manifest</p>
                        <p>:</p>
                        <p>MNF - {formatDateMoment(moment(), 'HHmmss')}</p>
                    </div>
                    <div className={'flex items-center space-x-3'}>
                        <p className={'w-28'}>Tanggal Manifest</p>
                        <p>:</p>
                        <p>{formatDateMoment(moment(), 'DD MMMM YYYY')}</p>
                    </div>
                </div>
                <div className={'avo__manifest mt-10'}>
                    <table>
                        <thead>
                            <th>Kode Pesanan</th>
                            <th>Tanggal Pesanan</th>
                            <th>Pelanggan</th>
                            <th>Ekspedisi</th>
                            <th>Kode Ekspedisi</th>
                        </thead>
                        <tbody>
                            {list?.map((item, index) => (
                                <tr key={index}>
                                    <td>{item?.order_code}</td>
                                    <td>{formatDateMoment(item?.created_at, 'DD MMMM YYYY')}</td>
                                    <td>{item?.shipping_name}</td>
                                    <td className={'flex items-center space-x-4'}>
                                        <img src={item?.shipping_image_url} className={'w-16'} alt={'logo'} />
                                        <p>{item?.shipping_service}</p>
                                    </td>
                                    <td>{item?.awb}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className={'grid grid-cols-2 mt-10'}>
                    <div className={'flex flex-col items-center'}>
                        <p className={'h-32'}>Kurir</p>
                        <p>(.............................................)</p>
                    </div>
                    <div className={'flex flex-col items-center'}>
                        <p className={'h-32'}>Admin</p>
                        <p>(.............................................)</p>
                    </div>
                </div>
            </div>
            <div className={'flex items-center justify-between my-5 mx-4'}>
                <Button title={'Pindah ke Delivery'} loading={isLoading} onClick={printManifestHandler} />
                <Button title={'Print Manifest'} onClick={reactToPrintFn} />
            </div>
        </Modal>
    )
}
